import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { IconContext } from 'react-icons';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import List from '@shared/component/List';
import TextInput from '@shared/component/TextInput';
import { AuthContext } from '@shared/context/AuthContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { TextTruncate, checkUrlString, actionsPermissionValidator, ActionValues } from '@utils/static/commonUtils';
import CheckValidator from '@shared/checkValidator';
import Lists from '@shared/component/Lists';
import ReactStars from 'react-rating-stars-component';
import { FaArrowRight } from 'react-icons/fa6';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import { FaLongArrowAltRight } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { imageCompress } from '@utils/static/commonUtils';

interface FormData {
    name: string | null;
    phone: string | null;
    companyname: string | null;
    email: string | null;
}

export enum ModalType {
    EDIT,
    VIEW,
}

export function Transporter() {
    const [errors, setError] = useState<any>({
        name: {
            required: true,
            error: true,
            message: 'Please enter name',
            pattern: /^[A-Za-z\s.]+$/, ///^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g,
            maxLength: 50,
        },
        companyname: {
            required: true,
            error: true,
            message: 'Please enter company name',
            pattern: /^[a-zA-Z][\w&.'\s-]*$/u, ///^[A-Za-z0-9\s]+(([',. -][A-Za-z0-9\s ])?[A-Za-z0-9\s]*)*$/g, ///^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g,
            maxLength: 30,
        },
        phone: {
            required: true,
            error: true,
            message: 'Please enter phone number',
            pattern: /^[6-9]{1}[0-9]{9}$/,
            maxLength: 10,
        },
    });

    const [errors2, setError2] = useState<any>({
        // vehicle_no: {
        //     required: true,
        //     error: true,
        //     message: 'Please enter vehicle number',
        //     pattern: /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/,
        //     maxLength: 10
        // },
        gst: {
            required: true,
            error: true,
            pattern: /^[0-9A-Za-z]{15}$/,
            message: 'Please enter GST no.',
            maxLength: 15,
        },
        pan: {
            required: true,
            error: true,
            pattern: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
            message: 'Please enter PAN no.',
            maxLength: 10,
        },
        aadhar_no: {
            required: true,
            error: true,
            pattern: /^[0-9]{12}$/,
            message: 'Please enter aadhar no.',
            maxLength: 12,
        },
        aadhar: {
            required: false,
            error: true,
            message: 'Please upload aadhaar card',
        },
        gstDoc: {
            required: false,
            error: true,
            message: 'Please upload GST',
        },
        panDoc: {
            required: false,
            error: true,
            message: 'Please upload PAN card',
        },
        other: {
            required: false,
            error: false,
            message: 'Please upload',
        },
    });

    const { setLoader, demandStatus } = useContext(AuthContext);
    const listRef: any = useRef(null);

    const [showRating, SetShowRating] = useState(false);
    // all items list
    const [transporterList, setTransporterList] = useState([]);

    const [transporterData, setTransporterData] = useState<any>();

    const recordPerPage: any = 5;

    const [ratingData, setRatingData] = useState([]);

    // stores current id item which we are going to edit
    const [id, setId] = useState(null);
    const [userId, setUserId] = useState(null);

    // stores total result count of items
    const [recordCount, setRecordCount] = useState(0);

    // stores text input data into state
    const [formData, setFormData] = useState<any>({
        name: null,
        phone: null,
        companyname: null,
        email: null,
        gst: null,
        pan: null,
        aadhar_no: null,
        aadhar: null,
        gstDoc: null,
        panDoc: null,
        other: null,
    });

    const [isSubmit, setIsSubmit] = useState(false);
    const [edit, setEdit] = useState(false);
    const [modalType, setModalType] = useState<ModalType>(ModalType.EDIT);
    const [showHideModel, setShowHideModel] = useState(false);
    const [page, setPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(0);
    const [reviewCount, setReviewCount] = useState(0);
    const [locationData, setLocationData] = useState([]);

    // const [ratingData, setRatingData] = useState([]);

    const [columns, setColumns] = useState({
        id: 'ID',
        companyname: 'Company Name',
        name: 'Full Name',
        phone: 'Mobile No.',
        rating: 'Transporter Rating',
        'document_transporter.gstDoc': 'GST Certificate',
        'document_transporter.panDoc': 'PAN',
        'document_transporter.idProof': 'Aadhar',
        status: 'Status',
        // transporterAction: 'Action',
        ...(actionsPermissionValidator(location.pathname, ActionValues.Edit) ||
        actionsPermissionValidator(location.pathname, ActionValues.View)
            ? { transporterAction: 'Action' }
            : null),
    });

    /**
     * close or open modal handling
     * @param flag true or false according to modal
     */
    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
            setIsSubmit(false);
            if (!flag) {
                clearObjData();
                setEdit(false);
                setModalType(ModalType.EDIT);
            }
        } catch (error) {}
    };

    useEffect(() => {
        if (demandStatus) {
            getTransporter();
        }
    }, [demandStatus]);

    const getLocation = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll('location/?page=1&sort=createdAt&type=active', true, false);
            setLoader(false);
            setLocationData(data?.data?.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const handleShowRating = (flag: boolean) => {
        SetShowRating(flag);
    };

    // clear state of text input
    const clearObjData = () => {
        setFormData({ name: null, phone: null });
    };

    const searchItem = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const { data } = await APIService.getAll(
                `user/search/appusers?page=${page}&order=desc&sort=createdAt&search=${value}&type=transporter`,
                true,
                false,
            );
            setTransporterList(data.data);
            setRecordCount(data.count);
        } catch (err) {
            setLoader(false);
        }
    };

    const getTransporter = async (page: any = 1) => {
        try {
            setLoader(true);
            const { data } = await APIService.getAll(
                `user/get/allTransporterUser/?page=${page}&sort=createdAt`,
                true,
                false,
            );
            setLoader(false);
            const final = data.data.map(e => ({
                ...e,
                rating: e.rating_appUsers.reduce((sum, curr) => (sum += curr.rating), 0) / e.rating_appUsers.length,
            }));

            setTransporterList(final);
            setRecordCount(data?.count || 0);
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getTransporter();
        getLocation();
    }, []);

    const addTransporter = async () => {
        try {
            const isValid = await CheckValidator(errors, formData);
            setIsSubmit(!isValid);

            if (isValid) {
                setLoader(true);
                const addeddata = await APIService.post('user/app/', formData, true, true);
                setLoader(false);
                if (addeddata.status === 200) {
                    Notify('success', 'User  created successfully');
                    clearObjData();

                    handelModel(false);
                    getTransporter();
                    listRef.current.clearSearchBox();
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    // update status of user
    // from active to inactive or vice versa
    const updateStatus = async (item: any, status: any, id: any, page, search: any) => {
        try {
            setLoader(true);
            const { status } = await APIService.update('user/status/update', id, undefined, true, false);
            setLoader(false);
            if (status === 200) {
                Notify('success', 'Transporter status updated');
                searchItem(search.trim(), page);
                // getTransporter(page);
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const updateTransporter = async () => {
        try {
            console.log('formData', errors2, formData);

            const isValid = await CheckValidator(errors2, formData);

            console.log('isValid', isValid);

            setIsSubmit(!isValid);
            if (isValid) {
                const data = {
                    name: formData.name,
                    // phone: formData.phone,
                    // companyname: formData.companyname,
                    email: formData.email,
                    other: formData?.other,
                    gstNo: formData?.gst,
                    panNo: formData?.pan,
                    aadharNo: formData?.aadhar_no,
                };

                if (formData?.aadhar) {
                    data['idProof'] = formData?.aadhar;
                }
                if (formData?.gstDoc) {
                    data['gstDoc'] = formData?.gstDoc;
                }
                if (formData?.panDoc) {
                    data['panDoc'] = formData?.panDoc;
                }

                setLoader(true);
                const { status } = await APIService.update('user/update/transporter/profile', id, data, true, true);
                setLoader(false);
                if (status === 200) {
                    errors['companyname'] = {
                        required: true,
                        error: true,
                        message: 'Please enter company name',
                        pattern: /^[A-Za-z0-9\s]+(([',. -][A-Za-z0-9\s ])?[A-Za-z0-9\s]*)*$/g, ///^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g,
                        maxLength: 30,
                    };

                    setError(errors);
                    handelModel(false);
                    setEdit(false);
                    Notify('success', 'Transporter updated successfully');
                    clearObjData();
                    getTransporter();
                    listRef.current.clearSearchBox(true);
                }
            }
        } catch (err) {
            console.log(err, 'err');
            setLoader(false);
        }
    };

    function formatDate(dateString) {
        return moment(dateString).format('DD MMM YYYY | hh.mm A');
    }

    const onPageChange = selectedPage => {
        setPage(selectedPage + 1); // ReactPaginate starts counting from 0, so add 1 to get the actual page number
    };

    // get user details based on id for updating a user
    const getTransporterById = async (id: any, type: string, page: any = 1) => {
        try {
            // http://localhost:4000/api/rating/getRatingByUser?appUserId=8&startIndex=0&limit=10

            setUserId(id);
            const foundUser: any = transporterList.find((user: any) => user.id === id);
            if (foundUser) {
                if (type === 'edit') {
                    delete errors.companyname;
                    errors['email'] = {
                        required: true,
                        error: true,
                        message: 'Please enter email',
                        pattern: /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
                    };
                    setError(errors);
                    setEdit(true);
                    setModalType(ModalType.EDIT);
                    handelModel(true);
                    setId(id);
                    setFormData({
                        name: foundUser.name,
                        phone: foundUser.phone,
                        companyname: foundUser.companyname,
                        email: foundUser.email,
                        gst: foundUser?.document_transporter?.gstNo || null,
                        pan: foundUser?.document_transporter?.panNo || null,
                        aadhar_no: foundUser?.document_transporter?.aadharNo || null,
                        aadhar: foundUser?.document_transporter?.idProof || null,
                        gstDoc: foundUser?.document_transporter?.gstDoc || null,
                        panDoc: foundUser?.document_transporter?.panDoc || null,
                        other: foundUser?.document_transporter?.otherDoc || null,
                    });
                }
                if (type === 'view') {
                    const data = await APIService.getAll(
                        `rating/getRatingByUser?appUserId=${id}&page=${page}&limit=${recordPerPage}`,
                        id,
                        true,
                        false,
                    );
                    setRatingData(data.data.data);
                    setReviewCount(data.data.count);
                    setEdit(true);
                    setModalType(ModalType.VIEW);
                    handelModel(true);
                    setId(id);
                    setTransporterData(foundUser);
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    // get new value for text input
    const getValue = (e: any) => {
        console.log('----', e);
        const data = { ...formData, ...e };
        setFormData(data);
        return;
    };

    const setErrorField = (e: any) => {
        console.log('e', e);
        try {
            // errors2[e]['error'] = true;
            // setError2(errors2);
        } catch (error) {}
    };

    /**
     * delete users based on ids
     * @param ids id and name object in array
     */
    const getDeleteIds = async (ids: any) => {
        try {
            const data = {
                ids: JSON.stringify(ids),
            };
            setLoader(true);
            const { status } = await APIService.post(`user/deleteAppusers`, data, true, false);
            setLoader(false);
            if (status === 200) {
                Notify('success', 'App Users deleted successfully');
            }
            await getTransporter();
        } catch (error) {
            setLoader(false);
        }
    };

    const getPage = async (e: any) => {
        try {
            setPage(e + 1);
            setCurrentPage(e);
            const data = await APIService.getAll(
                `rating/getRatingByUser?appUserId=${userId}&page=${e + 1}&limit=${recordPerPage}`,
                id,
                true,
                false,
            );
            setRatingData(data.data.data);
        } catch (error) {}
    };

    const bulkUpload = (e: any) => {
        try {
        } catch (error) {}
    };

    const handlefile = async (files: FileList | null, type: any, e: any) => {
        try {
            if (files && files.length > 0) {
                const fileObj = files[0];

                // Check file size (3MB limit)
                const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
                if (!allowedTypes.includes(fileObj.type)) {
                    Notify('error', 'Invalid file format. Please choose a JPG, JPEG, PNG, or PDF file.');
                    e.target.value = null;
                    return;
                }
                if (fileObj.size > maxSize) {
                    Notify('error', 'File size must be less than 5 mb');
                    e.target.value = null;

                    // Reset in case of Error
                    if (type == 'other') {
                        setFormData({ ...formData, ['other']: null, ['otherfile']: undefined });
                    }
                    return;
                }

                const file: any = await imageCompress(fileObj);

                if (type == 'aadhar') {
                    const reader = new FileReader();

                    reader.addEventListener(
                        'load',
                        () => {
                            // convert image file to base64 string
                            setFormData({
                                ...formData,
                                ['aadhar']: file,
                                ['aadharfile']: file.name,
                                ['aadharpreview']: reader.result,
                            });
                        },
                        false,
                    );

                    if (file) {
                        reader.readAsDataURL(file);
                    }
                } else if (type == 'panDoc') {
                    const reader = new FileReader();

                    reader.addEventListener(
                        'load',
                        () => {
                            // convert image file to base64 string
                            setFormData({
                                ...formData,
                                ['panDoc']: file,
                                ['panfile']: file.name,
                                ['panpreview']: reader.result,
                            });
                        },
                        false,
                    );

                    if (file) {
                        reader.readAsDataURL(file);
                    }
                } else if (type == 'gstDoc') {
                    const reader = new FileReader();

                    reader.addEventListener(
                        'load',
                        () => {
                            // convert image file to base64 string
                            setFormData({
                                ...formData,
                                ['gstDoc']: file,
                                ['gstfile']: file.name,
                                ['gstpreview']: reader.result,
                            });
                        },
                        false,
                    );

                    if (file) {
                        reader.readAsDataURL(file);
                    }
                } else {
                    setFormData({ ...formData, ['other']: file, ['otherfile']: file.name });
                }
            }
        } catch (error) {}
    };

    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>Transporter Type</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    <Lists
                        ref={listRef}
                        headers={columns}
                        data={transporterList}
                        callPagination={getTransporter}
                        recordCount={recordCount}
                        updateStatus={updateStatus}
                        getById={getTransporterById}
                        addUpdateText="Transporter"
                        searchItem={searchItem}
                        // type={'app_transporter'}
                        type={'add+delete'}
                        from={'transporter_app_user'}
                        handelModel={(e: boolean) => handelModel(e)}
                        getDeleteIds={getDeleteIds}
                        bulkUpload={(e: boolean) => bulkUpload(e)}
                        locationData={locationData}
                    />
                    {showHideModel && (
                        <Modal
                            scrollable={true}
                            show={true}
                            onHide={() => handelModel(false)}
                            backdrop="static"
                            keyboard={false}
                            size={'lg'}
                        >
                            <Modal.Header closeButton={!showRating} onClick={clearObjData}>
                                <Modal.Title>
                                    {edit
                                        ? modalType === ModalType.EDIT
                                            ? 'Edit Transporter'
                                            : 'View Transporter'
                                        : 'Add New Transporter'}
                                </Modal.Title>
                                {showRating == true ? (
                                    <Button
                                        variant="outlined"
                                        className=" outlined_btn"
                                        onClick={() => handleShowRating(false)}
                                    >
                                        Back
                                    </Button>
                                ) : (
                                    ''
                                )}
                            </Modal.Header>
                            <Modal.Body>
                                {modalType === ModalType.EDIT ? (
                                    <div className="material_form_cover">
                                        <form
                                            id="cat-form"
                                            autoComplete="off"
                                            onSubmit={e => {
                                                e.preventDefault();
                                            }}
                                        >
                                            <div className="field_box ">
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <div className="form-floating">
                                                            <TextInput
                                                                data={{
                                                                    type: 'text',
                                                                    placeholder: 'Full Name',
                                                                    name: 'name',
                                                                    id: 'floatingInput',
                                                                }}
                                                                controlName="name"
                                                                isSubmit={isSubmit}
                                                                value={formData.name}
                                                                setValue={(e: any) => getValue(e)}
                                                                errorMsg={errors?.name.message}
                                                                inputProps={errors}
                                                            />
                                                        </div>
                                                    </div>
                                                    {!edit && (
                                                        <div className="col-sm-6">
                                                            <div className="form-floating">
                                                                <TextInput
                                                                    data={{
                                                                        type: 'text',
                                                                        placeholder: 'Company Name',
                                                                        name: 'companyname',
                                                                        id: 'floatingInput',
                                                                    }}
                                                                    controlName="companyname"
                                                                    isSubmit={isSubmit}
                                                                    value={formData.companyname}
                                                                    setValue={(e: any) => getValue(e)}
                                                                    errorMsg={errors?.companyname?.message}
                                                                    inputProps={errors}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    {edit && (
                                                        <div className="col-sm-6">
                                                            <div className="form-floating">
                                                                <TextInput
                                                                    data={{
                                                                        type: 'text',
                                                                        placeholder: 'Email',
                                                                        name: 'email',
                                                                        id: 'floatingInput',
                                                                    }}
                                                                    controlName="email"
                                                                    isSubmit={isSubmit}
                                                                    value={formData.email}
                                                                    setValue={(e: any) => getValue(e)}
                                                                    errorMsg={errors?.email.message}
                                                                    inputProps={errors}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="col-sm-6">
                                                        <div className="form-floating ">
                                                            <TextInput
                                                                data={{
                                                                    type: 'number',
                                                                    placeholder: 'Phone',
                                                                    name: 'phone',
                                                                    id: 'floatingInput',
                                                                }}
                                                                readOnly={edit}
                                                                controlName="phone"
                                                                isSubmit={isSubmit}
                                                                value={formData.phone}
                                                                setValue={(e: any) => getValue(e)}
                                                                errorMsg={errors?.phone.message}
                                                                inputProps={errors}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6"></div>
                                                    {edit && (
                                                        <>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'text',
                                                                            placeholder: 'GST',
                                                                            name: 'gst',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="gst"
                                                                        isSubmit={isSubmit}
                                                                        errorMsg={errors2?.gst.message}
                                                                        inputProps={errors2}
                                                                        value={formData?.gst}
                                                                        setValue={(e: any) => getValue(e)}
                                                                        setErrorField={(e: any) => setErrorField(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <div
                                                                        className="form-control"
                                                                        style={{
                                                                            marginBottom: '10px',
                                                                            cursor: 'pointer',
                                                                            borderRadius: '8px',
                                                                            border: '1px solid #e8e9ec',
                                                                        }}
                                                                        onClick={() => {
                                                                            document.getElementById('gstDoc')?.click();
                                                                        }}
                                                                    >
                                                                        <span className="drop-zone__prompt">
                                                                            {' '}
                                                                            {formData?.gstfile !== undefined ? (
                                                                                formData.gstfile
                                                                            ) : (
                                                                                <>
                                                                                    <span
                                                                                        className="d-flex"
                                                                                        style={{
                                                                                            justifyContent:
                                                                                                'space-between',
                                                                                            flexDirection: 'row',
                                                                                        }}
                                                                                    >
                                                                                        Upload Document (.jpg, .png,
                                                                                        .pdf)Max size: 5MB
                                                                                        <span className="material-symbols-outlined">
                                                                                            upload
                                                                                        </span>
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                        </span>
                                                                        <input
                                                                            type="file"
                                                                            name="myFile"
                                                                            className="drop-zone__input"
                                                                            id="gstDoc"
                                                                            accept=".jpeg, .jpg, .png, .pdf"
                                                                            onChange={e => {
                                                                                handlefile(e.target.files, 'gstDoc', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                {formData?.gstfile !== undefined ? (
                                                                    <div>
                                                                        {formData?.gstfile?.split('.')[1] != 'png'}
                                                                        {formData?.gstfile?.split('.')[1] != 'jpeg' &&
                                                                        formData?.gstfile.split('.')[1] != 'jpg' &&
                                                                        formData?.gstfile.split('.')[1] != 'png' ? (
                                                                            <div className="vendorpdf">
                                                                                <img
                                                                                    src="./assets/images/pdficon.svg"
                                                                                    className="img-fluid"
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="vendorimage">
                                                                                <img
                                                                                    src={formData?.gstpreview}
                                                                                    className="img-fluid w-100 h-100"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            className="vendorpdftext"
                                                                            style={{ marginBottom: '30px' }}
                                                                        >
                                                                            {formData?.gstfile !== undefined
                                                                                ? formData.gstfile
                                                                                : 'Upload file'}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className="vendorform"
                                                                        style={{ marginBottom: '30px' }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                formData?.gstDoc
                                                                                    ? process.env.REACT_APP_API_BASE +
                                                                                      formData?.gstDoc
                                                                                    : './assets/images/registrationform.svg'
                                                                            }
                                                                            className="img-fluid add-aspect-ratio"
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="col-sm-6"></div>

                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'text',
                                                                            placeholder: 'PAN',
                                                                            name: 'pan',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="pan"
                                                                        isSubmit={isSubmit}
                                                                        errorMsg={errors2?.pan.message}
                                                                        inputProps={errors2}
                                                                        value={formData?.pan}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <div
                                                                        className="form-control"
                                                                        style={{
                                                                            marginBottom: '10px',
                                                                            cursor: 'pointer',
                                                                            borderRadius: '8px',
                                                                            border: '1px solid #e8e9ec',
                                                                        }}
                                                                        onClick={() => {
                                                                            document.getElementById('panDoc')?.click();
                                                                        }}
                                                                    >
                                                                        <span className="drop-zone__prompt">
                                                                            {' '}
                                                                            {formData?.panfile !== undefined ? (
                                                                                formData.panfile
                                                                            ) : (
                                                                                <>
                                                                                    <span
                                                                                        className="d-flex"
                                                                                        style={{
                                                                                            justifyContent:
                                                                                                'space-between',
                                                                                            flexDirection: 'row',
                                                                                        }}
                                                                                    >
                                                                                        Upload Document (.jpg, .png,
                                                                                        .pdf) Max size: 5MB
                                                                                        <span className="material-symbols-outlined">
                                                                                            upload
                                                                                        </span>
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                        </span>
                                                                        <input
                                                                            type="file"
                                                                            name="myFile"
                                                                            className="drop-zone__input"
                                                                            id="panDoc"
                                                                            accept=".jpeg, .jpg, .png, .pdf"
                                                                            onChange={e => {
                                                                                handlefile(e.target.files, 'panDoc', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-6">
                                                                {formData?.panfile !== undefined ? (
                                                                    <div>
                                                                        {formData?.panfile?.split('.')[1] != 'png'}
                                                                        {formData?.panfile?.split('.')[1] != 'jpeg' &&
                                                                        formData?.panfile.split('.')[1] != 'jpg' &&
                                                                        formData?.panfile.split('.')[1] != 'png' ? (
                                                                            <div className="vendorpdf">
                                                                                <img
                                                                                    src="./assets/images/pdficon.svg"
                                                                                    className="img-fluid"
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="vendorimage">
                                                                                <img
                                                                                    src={formData?.panpreview}
                                                                                    className="img-fluid w-100 h-100"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            className="vendorpdftext"
                                                                            style={{ marginBottom: '30px' }}
                                                                        >
                                                                            {formData?.panfile !== undefined
                                                                                ? formData.panfile
                                                                                : 'Upload file'}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className="vendorform"
                                                                        style={{ marginBottom: '30px' }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                formData?.panDoc
                                                                                    ? process.env.REACT_APP_API_BASE +
                                                                                      formData?.panDoc
                                                                                    : './assets/images/registrationform.svg'
                                                                            }
                                                                            className="img-fluid add-aspect-ratio"
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-6"></div>

                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'number',
                                                                            placeholder: 'Aadhar',
                                                                            name: 'aadhar_no',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="aadhar_no"
                                                                        isSubmit={isSubmit}
                                                                        errorMsg={errors2?.aadhar_no.message}
                                                                        inputProps={errors2}
                                                                        value={formData?.aadhar_no}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <div
                                                                        className="form-control"
                                                                        style={{
                                                                            marginBottom: '10px',
                                                                            cursor: 'pointer',
                                                                            borderRadius: '8px',
                                                                            border: '1px solid #e8e9ec',
                                                                        }}
                                                                        onClick={() => {
                                                                            document.getElementById('aadhar')?.click();
                                                                        }}
                                                                    >
                                                                        <span className="drop-zone__prompt">
                                                                            {' '}
                                                                            {formData?.aadharfile !== undefined ? (
                                                                                formData.aadharfile
                                                                            ) : (
                                                                                <>
                                                                                    <span
                                                                                        className="d-flex"
                                                                                        style={{
                                                                                            justifyContent:
                                                                                                'space-between',
                                                                                            flexDirection: 'row',
                                                                                        }}
                                                                                    >
                                                                                        Upload Document (.jpg, .png,
                                                                                        .pdf)Max size: 5MB
                                                                                        <span className="material-symbols-outlined">
                                                                                            upload
                                                                                        </span>
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                        </span>
                                                                        <input
                                                                            type="file"
                                                                            name="myFile"
                                                                            className="drop-zone__input"
                                                                            accept=".jpeg, .jpg, .png, .pdf"
                                                                            id="aadhar"
                                                                            onChange={e => {
                                                                                handlefile(e.target.files, 'aadhar', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                {formData?.aadharfile !== undefined ? (
                                                                    <div>
                                                                        {formData?.aadharfile?.split('.')[1] != 'png'}
                                                                        {formData?.aadharfile?.split('.')[1] !=
                                                                            'jpeg' &&
                                                                        formData?.aadharfile.split('.')[1] != 'jpg' &&
                                                                        formData?.aadharfile.split('.')[1] != 'png' ? (
                                                                            <div className="vendorpdf">
                                                                                <img
                                                                                    src="./assets/images/pdficon.svg"
                                                                                    className="img-fluid"
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="vendorimage">
                                                                                <img
                                                                                    src={formData?.aadharpreview}
                                                                                    className="img-fluid w-100 h-100"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            className="vendorpdftext"
                                                                            style={{ marginBottom: '30px' }}
                                                                        >
                                                                            {formData?.aadharfile !== undefined
                                                                                ? formData.aadharfile
                                                                                : 'Upload file'}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className="vendorform"
                                                                        style={{ marginBottom: '30px' }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                formData?.aadhar
                                                                                    ? process.env.REACT_APP_API_BASE +
                                                                                      formData?.aadhar
                                                                                    : './assets/images/registrationform.svg'
                                                                            }
                                                                            className="img-fluid add-aspect-ratio"
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-6"></div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                ) : showRating == false ? (
                                    <div className="detail_modal_cover">
                                        <div className="details_box_cover">
                                            <div className="container">
                                                <h3>User Details</h3>

                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <span className="sub_box">Company Name :</span>
                                                                <span className="main_box">
                                                                    {transporterData?.companyname}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="sub_box">Mobile No. :</span>
                                                                <span className="main_box">
                                                                    {transporterData?.phone}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="sub_box">Category :</span>
                                                                <span className="main_box">
                                                                    {transporterData?.category?.name}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <span className="sub_box">Owner Name :</span>
                                                                <span className="main_box">
                                                                    {transporterData && transporterData?.name
                                                                        ? transporterData.name
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="sub_box">Email :</span>
                                                                <span className="main_box">
                                                                    {transporterData && transporterData?.email
                                                                        ? transporterData.email
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="sub_box">State :</span>
                                                                <span className="main_box">
                                                                    {transporterData &&
                                                                    transporterData?.document_transporter?.state
                                                                        ? transporterData.document_transporter.state
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <span className="sub_box">City :</span>
                                                                <span className="main_box">
                                                                    {transporterData &&
                                                                    transporterData?.document_transporter?.city
                                                                        ? transporterData.document_transporter.city
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="sub_box">Pincode :</span>
                                                                <span className="main_box">
                                                                    {transporterData &&
                                                                    transporterData?.document_transporter?.pincode
                                                                        ? transporterData.document_transporter.pincode
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div className="col-sm-6">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <span className="sub_box">Full Address :</span>
                                                                <span className="main_box">
                                                                    {transporterData &&
                                                                    transporterData?.document_transporter?.address
                                                                        ? transporterData.document_transporter.address
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <hr />
                                                <h3>Documents :</h3>
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <p className="sub_box">Aadhar No. </p>
                                                                <p className="main_box">
                                                                    {transporterData &&
                                                                    transporterData?.document_transporter?.aadharNo
                                                                        ? transporterData.document_transporter.aadharNo
                                                                        : 'N/A'}
                                                                </p>
                                                                {transporterData?.document_transporter?.idProof ? (
                                                                    <>
                                                                        <p className="sub_box">Uploaded Document </p>
                                                                        <a
                                                                            href={
                                                                                process.env.REACT_APP_API_BASE +
                                                                                transporterData?.document_transporter
                                                                                    ?.idProof
                                                                            }
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                        >
                                                                            <div>
                                                                                {transporterData?.document_transporter?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'png'}
                                                                                {transporterData?.document_transporter?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'jpeg' &&
                                                                                transporterData?.document_transporter?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'jpg' &&
                                                                                transporterData?.document_transporter?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'png' ? (
                                                                                    <div className="previewpdfsignup">
                                                                                        <img
                                                                                            src="./assets/images/pdficon.svg"
                                                                                            className="img-fluid"
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="previewimagesignup">
                                                                                        <img
                                                                                            src={
                                                                                                process.env
                                                                                                    .REACT_APP_API_BASE +
                                                                                                transporterData
                                                                                                    ?.document_transporter
                                                                                                    ?.idProof
                                                                                            }
                                                                                            className="img-fluid w-100 h-100"
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                                <div className="previewimagesignuptext">
                                                                                    {transporterData?.document_transporter?.idProof
                                                                                        .split('documents')[1]
                                                                                        .slice(12)}
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <p className="sub_box">PAN No. </p>
                                                                <p className="main_box">
                                                                    {transporterData &&
                                                                    transporterData?.document_transporter?.panNo
                                                                        ? transporterData.document_transporter.panNo
                                                                        : 'N/A'}
                                                                </p>
                                                                {transporterData?.document_transporter?.panDoc ? (
                                                                    <>
                                                                        <p className="sub_box">Uploaded Document </p>
                                                                        <a
                                                                            href={
                                                                                process.env.REACT_APP_API_BASE +
                                                                                transporterData?.document_transporter
                                                                                    ?.panDoc
                                                                            }
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                        >
                                                                            <div>
                                                                                {transporterData?.document_transporter?.panDoc.split(
                                                                                    '.',
                                                                                )[1] != 'png'}
                                                                                {transporterData?.document_transporter?.panDoc.split(
                                                                                    '.',
                                                                                )[1] != 'jpeg' &&
                                                                                transporterData?.document_transporter?.panDoc.split(
                                                                                    '.',
                                                                                )[1] != 'jpg' &&
                                                                                transporterData?.document_transporter?.panDoc.split(
                                                                                    '.',
                                                                                )[1] != 'png' ? (
                                                                                    <div className="previewpdfsignup">
                                                                                        <img
                                                                                            src="./assets/images/pdficon.svg"
                                                                                            className="img-fluid"
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="previewimagesignup">
                                                                                        <img
                                                                                            src={
                                                                                                process.env
                                                                                                    .REACT_APP_API_BASE +
                                                                                                transporterData
                                                                                                    ?.document_transporter
                                                                                                    ?.panDoc
                                                                                            }
                                                                                            className="img-fluid w-100 h-100"
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                                <div className="previewimagesignuptext">
                                                                                    {transporterData?.document_transporter?.panDoc
                                                                                        .split('documents')[1]
                                                                                        .slice(12)}
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <p className="sub_box">GST Certificate No.</p>
                                                                <p className="main_box">
                                                                    {transporterData &&
                                                                    transporterData?.document_transporter?.gstNo
                                                                        ? transporterData.document_transporter.gstNo
                                                                        : 'N/A'}
                                                                </p>
                                                                {transporterData?.document_transporter?.gstDoc ? (
                                                                    <>
                                                                        <p className="sub_box">Uploaded Document </p>
                                                                        <a
                                                                            href={
                                                                                process.env.REACT_APP_API_BASE +
                                                                                transporterData?.document_transporter
                                                                                    ?.gstDoc
                                                                            }
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                        >
                                                                            <div>
                                                                                {transporterData?.document_transporter?.gstDoc.split(
                                                                                    '.',
                                                                                )[1] != 'png'}
                                                                                {transporterData?.document_transporter?.gstDoc.split(
                                                                                    '.',
                                                                                )[1] != 'jpeg' &&
                                                                                transporterData?.document_transporter?.gstDoc.split(
                                                                                    '.',
                                                                                )[1] != 'jpg' &&
                                                                                transporterData?.document_transporter?.gstDoc.split(
                                                                                    '.',
                                                                                )[1] != 'png' ? (
                                                                                    <div className="previewpdfsignup">
                                                                                        <img
                                                                                            src="./assets/images/pdficon.svg"
                                                                                            className="img-fluid"
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="previewimagesignup">
                                                                                        <img
                                                                                            src={
                                                                                                process.env
                                                                                                    .REACT_APP_API_BASE +
                                                                                                transporterData
                                                                                                    ?.document_transporter
                                                                                                    ?.gstDoc
                                                                                            }
                                                                                            className="img-fluid w-100 h-100"
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                                <div className="previewimagesignuptext">
                                                                                    {transporterData?.document_transporter?.gstDoc
                                                                                        .split('documents')[1]
                                                                                        .slice(12)}
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    {transporterData?.document_transporter?.otherDoc ? (
                                                        <div className="col-sm-4">
                                                            <ul className="detail_list">
                                                                <li>
                                                                    <p className="sub_box">Other</p>

                                                                    {transporterData?.document_transporter?.otherDoc ? (
                                                                        <>
                                                                            <p className="sub_box">
                                                                                Uploaded Document{' '}
                                                                            </p>
                                                                            <a
                                                                                href={
                                                                                    process.env.REACT_APP_API_BASE +
                                                                                    transporterData
                                                                                        ?.document_transporter?.otherDoc
                                                                                }
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                            >
                                                                                <div>
                                                                                    {transporterData?.document_transporter?.otherDoc.split(
                                                                                        '.',
                                                                                    )[1] != 'png'}
                                                                                    {transporterData?.document_transporter?.otherDoc.split(
                                                                                        '.',
                                                                                    )[1] != 'jpeg' &&
                                                                                    transporterData?.document_transporter?.otherDoc.split(
                                                                                        '.',
                                                                                    )[1] != 'jpg' &&
                                                                                    transporterData?.document_transporter?.otherDoc.split(
                                                                                        '.',
                                                                                    )[1] != 'png' ? (
                                                                                        <div className="previewpdfsignup">
                                                                                            <img
                                                                                                src="./assets/images/pdficon.svg"
                                                                                                className="img-fluid"
                                                                                            />
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="previewimagesignup">
                                                                                            <img
                                                                                                src={
                                                                                                    process.env
                                                                                                        .REACT_APP_API_BASE +
                                                                                                    transporterData
                                                                                                        ?.document_transporter
                                                                                                        ?.otherDoc
                                                                                                }
                                                                                                className="img-fluid w-100 h-100"
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="previewimagesignuptext">
                                                                                        {transporterData?.document_transporter?.otherDoc
                                                                                            .split('documents')[1]
                                                                                            .slice(12)}
                                                                                    </div>
                                                                                </div>
                                                                            </a>
                                                                        </>
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                {transporterData && transporterData.rating > 0 && (
                                                    <div className="detail_modal_cover">
                                                        <div className="row">
                                                            <h3>Rating & Reviews</h3>
                                                            <div style={{ display: 'flex' }}>
                                                                {transporterData?.rating && (
                                                                    <>
                                                                        <ReactStars
                                                                            count={5}
                                                                            value={transporterData?.rating}
                                                                            size={15}
                                                                            isHalf={true}
                                                                            emptyIcon={
                                                                                <i
                                                                                    className="fa fa-star"
                                                                                    style={{ color: 'green' }}
                                                                                ></i>
                                                                            }
                                                                            halfIcon={
                                                                                <i
                                                                                    className="fa fa-star-half-alt"
                                                                                    style={{ color: 'white' }}
                                                                                ></i>
                                                                            }
                                                                            fullIcon={
                                                                                <i
                                                                                    className="fa fa-star"
                                                                                    style={{ color: 'white' }}
                                                                                ></i>
                                                                            }
                                                                            activeColor="#FFA800"
                                                                            edit={false}
                                                                        />
                                                                        {`(${transporterData.rating.toFixed(1)})`}
                                                                        {'| Total' +
                                                                            ' ' +
                                                                            transporterData?.rating_appUsers?.length +
                                                                            ' Reviews'}
                                                                    </>
                                                                )}
                                                            </div>

                                                            <div className="rating_box_cover">
                                                                {[
                                                                    ...(showRating
                                                                        ? ratingData
                                                                        : ratingData.slice(0, 2)),
                                                                ].map((data, index) => (
                                                                    <div className="rating_item" key={index}>
                                                                        <div className="rating_text">
                                                                            <ul className="loc_box_cover">
                                                                                <li>
                                                                                    <div className="loc_box">
                                                                                        {data?.bid?.demand?.from
                                                                                            ?.city && (
                                                                                            <span className="item">
                                                                                                From:{' '}
                                                                                                {
                                                                                                    data.bid?.demand
                                                                                                        ?.from?.city
                                                                                                }
                                                                                            </span>
                                                                                        )}
                                                                                        {data?.bid
                                                                                            ?.actualDeliveryDate && (
                                                                                            <span className="item">
                                                                                                Date From:{' '}
                                                                                                {formatDate(
                                                                                                    data.bid
                                                                                                        ?.actualDeliveryDate,
                                                                                                )}
                                                                                            </span>
                                                                                        )}
                                                                                        {data?.bid?.demand?.mid
                                                                                            ?.city && (
                                                                                            <span className="item">
                                                                                                Mid:{' '}
                                                                                                {
                                                                                                    data.bid.demand?.mid
                                                                                                        ?.city
                                                                                                }
                                                                                            </span>
                                                                                        )}
                                                                                        {data?.bid?.demand?.to
                                                                                            ?.city && (
                                                                                            <span className="item">
                                                                                                To:{' '}
                                                                                                {
                                                                                                    data.bid.demand?.to
                                                                                                        ?.city
                                                                                                }
                                                                                            </span>
                                                                                        )}
                                                                                        {data?.bid
                                                                                            ?.deliveredDeliveryDate && (
                                                                                            <span className="item">
                                                                                                Date To:{' '}
                                                                                                {formatDate(
                                                                                                    data.bid
                                                                                                        ?.deliveredDeliveryDate,
                                                                                                )}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                </li>
                                                                            </ul>
                                                                            <ReactStars
                                                                                count={5}
                                                                                value={data?.rating}
                                                                                size={15}
                                                                                isHalf={true}
                                                                                emptyIcon={
                                                                                    <i
                                                                                        className="fa fa-star"
                                                                                        style={{ color: 'green' }}
                                                                                    ></i>
                                                                                }
                                                                                halfIcon={
                                                                                    <i
                                                                                        className="fa fa-star-half-alt"
                                                                                        style={{ color: 'white' }}
                                                                                    ></i>
                                                                                }
                                                                                fullIcon={
                                                                                    <i
                                                                                        className="fa fa-star"
                                                                                        style={{ color: 'white' }}
                                                                                    ></i>
                                                                                }
                                                                                activeColor="#FFA800"
                                                                                edit={false}
                                                                            />
                                                                            {data?.remark && <p>{data?.remark}</p>}
                                                                        </div>
                                                                    </div>
                                                                ))}

                                                                {ratingData.length > 2 ? (
                                                                    <a
                                                                        // variant="secondary"
                                                                        className="btn custom_btn full_btn"
                                                                        onClick={() => handleShowRating(true)}
                                                                    >
                                                                        View More
                                                                    </a>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="detail_modal_cover no_gap_detail_modal_cover">
                                            <h3>Rating & Reviews</h3>
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            {transporterData?.rating && (
                                                <>
                                                    <ReactStars
                                                        count={5}
                                                        value={transporterData?.rating}
                                                        size={15}
                                                        isHalf={true}
                                                        emptyIcon={
                                                            <i className="fa fa-star" style={{ color: 'green' }}></i>
                                                        }
                                                        halfIcon={
                                                            <i
                                                                className="fa fa-star-half-alt"
                                                                style={{ color: 'white' }}
                                                            ></i>
                                                        }
                                                        fullIcon={
                                                            <i className="fa fa-star" style={{ color: 'white' }}></i>
                                                        }
                                                        activeColor="#FFA800"
                                                        edit={false}
                                                    />
                                                    {`(${transporterData.rating.toFixed(1)})`}
                                                    {'|Total' +
                                                        ' ' +
                                                        transporterData?.rating_appUsers?.length +
                                                        ' Reviews'}
                                                </>
                                            )}
                                        </div>

                                        <div className="rating_box_cover">
                                            {ratingData.map((data, index) => (
                                                <div className="rating_item" key={index}>
                                                    <div className="rating_text">
                                                        <ul className="loc_box_cover">
                                                            <li>
                                                                <div className="loc_box">
                                                                    {data.bid.demand?.from?.city && (
                                                                        <span className="item">
                                                                            From: {data.bid?.demand?.from?.city}
                                                                        </span>
                                                                    )}
                                                                    {data.bid.actualDeliveryDate && (
                                                                        <span className="item">
                                                                            Date From:{' '}
                                                                            {formatDate(data.bid.actualDeliveryDate)}
                                                                            <GoArrowRight
                                                                                style={{
                                                                                    fontSize: 24,
                                                                                    margin: '0 15px',
                                                                                }}
                                                                            />
                                                                        </span>
                                                                    )}
                                                                    {data.bid.demand?.mid?.city && (
                                                                        <span className="item">
                                                                            Mid: {data.bid.demand.mid.city}
                                                                            <GoArrowRight
                                                                                style={{
                                                                                    fontSize: 24,
                                                                                    margin: '0 15px',
                                                                                }}
                                                                            />
                                                                        </span>
                                                                    )}
                                                                    {data.bid.demand?.to?.city && (
                                                                        <span className="item">
                                                                            To: {data.bid.demand.to.city}
                                                                        </span>
                                                                    )}
                                                                    {data.bid.deliveredDeliveryDate && (
                                                                        <span className="item">
                                                                            Date To:{' '}
                                                                            {formatDate(data.bid.deliveredDeliveryDate)}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        {/* Add your ReactStars and other content here */}
                                                        <ReactStars
                                                            count={5}
                                                            value={data.rating}
                                                            size={15}
                                                            isHalf={true}
                                                            emptyIcon={
                                                                <i
                                                                    className="fa fa-star"
                                                                    style={{ color: 'green' }}
                                                                ></i>
                                                            }
                                                            halfIcon={
                                                                <i
                                                                    className="fa fa-star-half-alt"
                                                                    style={{ color: 'white' }}
                                                                ></i>
                                                            }
                                                            fullIcon={
                                                                <i
                                                                    className="fa fa-star"
                                                                    style={{ color: 'white' }}
                                                                ></i>
                                                            }
                                                            activeColor="#FFA800"
                                                            edit={false}
                                                        />
                                                        {data.remark && <p>{data.remark}</p>}
                                                    </div>
                                                </div>
                                            ))}

                                            {ratingData?.length > 0 && reviewCount > 1 && (
                                                <div className="pageApp">
                                                    <p>
                                                        Showing {(page - 1) * recordPerPage + 1} to{' '}
                                                        {Math.min(page * recordPerPage, reviewCount)} of{' '}
                                                        <span style={{ fontWeight: 600 }}>{reviewCount}</span> entries
                                                    </p>
                                                    <ReactPaginate
                                                        forcePage={currentPage}
                                                        containerClassName={'pagination'}
                                                        activeClassName={'active'}
                                                        pageClassName={'page-item'}
                                                        onPageChange={(event: any) => getPage(event.selected)}
                                                        breakLabel="..."
                                                        pageCount={Math.ceil(reviewCount / recordPerPage)}
                                                        previousLabel={
                                                            <IconContext.Provider
                                                                value={{ color: '#B8C1CC', size: '36px' }}
                                                            >
                                                                Back
                                                            </IconContext.Provider>
                                                        }
                                                        nextLabel={
                                                            <IconContext.Provider
                                                                value={{ color: '#B8C1CC', size: '36px' }}
                                                            >
                                                                Next
                                                            </IconContext.Provider>
                                                        }
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </Modal.Body>
                            {modalType === ModalType.EDIT && (
                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        className="btn dark_btn custom_btn"
                                        onClick={edit ? updateTransporter : addTransporter}
                                    >
                                        {edit ? 'Update' : 'Add'}
                                    </Button>
                                    <Button
                                        variant="default"
                                        className="btn custom_btn border_btn with_icon"
                                        onClick={() => handelModel(false)}
                                    >
                                        Cancel
                                    </Button>
                                </Modal.Footer>
                            )}
                        </Modal>
                    )}
                </div>
            </div>
        </>
    );
}
